//export const _baseApiUrl = "http://localhost:5000/api";        // local API
//export const _baseApiUrl = "https://dev.weboutdoor.ru/api";    // DEV API
export const _baseApiUrl = "https://bulk.weboutdoor.ru/api";     // PROD API 